/**
 * 由 CoCo 源代码计划解包器解包
 *
 * 模块 ID：1519
 */

module.exports = {
  content: "Align_content__2G0lt"
}
